export { default } from "../objectSpread2/_index.mjs"